import React from "react";

function Card({ handleShop, products}) {
  
  return (
    <>
      <h3>
        Moedas<p>Antigas</p>
      </h3>
      
      
        {products.map((item) => (
          <div className="card" key={item.id}>
            <div className="card_img">
              <img src={item.thumb} alt="" />
            </div>
            <div key={item.id} className="card_header">
              <h2>{item.product_name}</h2>
              <p>{item.description}</p>
              <p className="price">
                {item.price}
                <span>{item.currency}</span>
              </p>
              <div onClick={() => handleShop(item)} className="btn">
                Adicionar
              </div>
            </div>
          </div>
        ))}
        </>
      
   
  );
}

export default Card;
